import md5 from "blueimp-md5";

window.md5 = md5;

const canFireEvents = () =>
  typeof window !== "undefined" && window.digitalData && window.PubSub;

const ensureFormObjectInitialized = () => {
  if (!window.digitalData.page) {
    window.digitalData.page = {};
  }

  if (!window.digitalData.page.form) {
    window.digitalData.page.form = {};
  }
};

export const fireFormStart = ({ name = "", type = "" }) => {
  if (canFireEvents()) {
    ensureFormObjectInitialized();

    window.digitalData.page.form.formName = name;
    window.digitalData.page.form.formType = type;

    window.PubSub.publish("analytics.formStart", {});
  }
};

export const fireFormSubmitSuccess = ({ hashableIdentifier = false, name = "", type = "" }) => {
  if (canFireEvents()) {
    ensureFormObjectInitialized();

    window.digitalData.page.form.formName = name;
    window.digitalData.page.form.formType = type;

    if (hashableIdentifier) {
      window.digitalData.page.form.formEmail = md5(hashableIdentifier);
    }

    window.PubSub.publish("analytics.formSuccess", {});
  }
};

export const fireFormSubmitFail = ({
  invalidFieldNames = [],
  name = "",
  type = ""
}) => {
  if (canFireEvents()) {
    ensureFormObjectInitialized();

    window.digitalData.page.form.formName = name;
    window.digitalData.page.form.formType = type;
    window.digitalData.page.form.formErrors = invalidFieldNames.join(",");

    window.PubSub.publish("analytics.formErrors", {});
  }
};



// WEBPACK FOOTER //
// ./js/analytics/dtm.js